import { useState } from 'react';

import { Dropdown, Input } from '../../../components';
import {
  CUSTOM_SIP_ADDRESS_VALUE,
  PRESET_SIP_ADDRESS_VALUES,
  SIP_ADDRESS_OPTIONS,
} from './constants';

type SipAddressFieldProps = {
  value?: string;
  disabled?: boolean;
  onChange?: (newValue: string) => void;
};

const isPresetSipAddress = (value?: string): value is string =>
  !!value && PRESET_SIP_ADDRESS_VALUES.includes(value);

export const SipAddressField: React.FC<SipAddressFieldProps> = ({
  value,
  disabled = false,
  onChange,
}) => {
  const [isCustom, setIsCustom] = useState<boolean>(
    !!value && !isPresetSipAddress(value)
  );

  const dropdownValue = isCustom ? CUSTOM_SIP_ADDRESS_VALUE : (value ?? '');

  const handleSelect = (selected: string) => {
    if (selected === CUSTOM_SIP_ADDRESS_VALUE) {
      setIsCustom(true);
      onChange?.('');
      return;
    }

    setIsCustom(false);
    onChange?.(selected);
  };

  const handleCustomChange = (newValue: string) => {
    onChange?.(newValue);
  };

  return (
    <div className="flex flex-col gap-y-md w-full">
      <Dropdown
        disabled={disabled}
        value={dropdownValue}
        options={SIP_ADDRESS_OPTIONS}
        onChange={handleSelect}
        placeholder="Select SIP Address"
      />
      {isCustom && (
        <Input
          disabled={disabled}
          value={value ?? ''}
          onChange={handleCustomChange}
          placeholder="Enter custom SIP address"
        />
      )}
    </div>
  );
};
